import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeProvider";
import { useT } from "@/i18n";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const t = useT();
  return (
    <button
      onClick={toggle}
      aria-label={t("theme.toggle")}
      data-testid="theme-toggle"
      className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-border text-foreground/80 transition-colors hover:bg-secondary active:scale-95"
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
